module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_vm._v("This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THOMAS DUNNE BOOKS")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_vm._v("An imprint of St. Martin’s Press.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAIDERS FROM THE NORTH")]), _vm._v(". Copyright © 2009 by Alex Rutherford. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_c('a', {
    attrs: {
      "href": "http://www.thomasdunnebooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.thomasdunnebooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-para1"
  }, [_vm._v("Rutherford, Alex, 1948-")]), _vm._v(" "), _c('p', {
    staticClass: "left-para2"
  }, [_vm._v("Raiders from the north : empire of the Moghul /Alex")]), _vm._v(" "), _c('p', {
    staticClass: "left-para1"
  }, [_vm._v("Rutherford.—1st U.S. ed.")]), _vm._v(" "), _c('p', {
    staticClass: "left-para3"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "left-para2"
  }, [_vm._v("    ISBN 978-0-312-59700-9")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("1. Farghona (Uzbekistan)—History—Fiction. 2. Babur, Emperor of Hindustan, 1483-1530—Fiction. 3. Mogul Empire—History-Fiction. 4. Mogul Empire—Kings and rulers—Fiction. I.Title.")]), _vm._v(" "), _c('p', {
    staticClass: "left-para1"
  }, [_vm._v("PR6118.U92R35 2010")]), _vm._v(" "), _c('p', {
    staticClass: "left-para1"
  }, [_vm._v("823'.92—dc22")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("2010002336")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_vm._v("First published in Great Britain by Headline Review, an imprint of Headline Publishing Group")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_vm._v("First U.S. Edition: May 2010")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-parac"
  }, [_vm._v("10 9 8 7 6 5 4 3 2 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8422d616","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 63
// module chunks = 0